import { useLingui } from '@lingui/react'
import { t, Trans } from '@lingui/macro'

import { LoadingButton } from '@mui/lab'
import { Chip, Stack } from '@mui/material'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'

import { InsIdentity, VitaleCardPatient } from '@/core/types/dmp-connect'
import { getVitalePatientQualityLabel } from '@/utils/patient'

import { useGetInsFromVitaleCard } from '../model/useGetInsFromVitaleCard'

type VitaleCardPatientOptionProps = {
  hideGetIns?: boolean
  index: number
  patient: VitaleCardPatient
  patientId?: string
  onIdentity: (index: number, identity: InsIdentity) => void
}

/** One beneficiary of the Vitale card: name, quality badge, and the "Get INS" action. */
export function VitaleCardPatientOption({ hideGetIns, index, patient, patientId, onIdentity }: VitaleCardPatientOptionProps) {
  useLingui()
  const { getIns, isLoading, hasResult, hasIdentity } = useGetInsFromVitaleCard({
    index,
    patient,
    patientId,
    onIdentity: (identity) => onIdentity(index, identity),
  })

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
      <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
        <span>{`${patient.s_name} - ${patient.s_given}`.trim()}</span>
        <Chip label={getVitalePatientQualityLabel(patient.i_quality)} size="small" />
        {hasIdentity && <Chip icon={<CheckCircleRoundedIcon />} label={t`INS`} size="small" />}
      </Stack>
      {!hideGetIns && !hasResult && (
        <LoadingButton loading={isLoading} onClick={getIns}>
          <Trans>Get INS</Trans>
        </LoadingButton>
      )}
    </Stack>
  )
}
